import axios from "axios";
import { API } from "../../../../config/UrlEndPoint";
import { gql } from "@apollo/client";
import { MutationGraphql, QueryGraphql } from "../../../../config/ApoloRequest";

export const CUSTOMERS_URL = `${API}marketplaceOrder/`;

// CREATE =>  POST: add a new marketplaceOrder to the server
// export function createMarketplaceOrder(marketplaceOrder) {
//   return axios.post(CUSTOMERS_URL, { marketplaceOrder });
// }

export async function findMarketplaceOrders(queryParams) {
  const query = gql`
    query Query(
      $page_number: Int
      $page_size: Int
      $status: String
      $is_marketplace: Boolean
      $member_uuid: String
      $branch_uuid: String
      $invoice_no: String
    ) {
      findOrder(
        findOrderInput: {
          status: $status
          page_number: $page_number
          page_size: $page_size
          is_from_marketplace: $is_marketplace
          member_uuid: $member_uuid
          branch_uuid: $branch_uuid
          invoice_no: $invoice_no
        }
      ) {
        items {
          invoice_no
          is_online
          status
          trx_date
          uuid
          branch {
            city
            province
          }
          order_payment {
            amount
          }
          member {
            name
          }
          order_delivery {
            awb
            city
            province
            shipping_service {
              company_code
              service
            }
          }
        }
        total_items
      }
    }
  `;

  const newResponse = await QueryGraphql(query, queryParams);
  return newResponse.data.findOrder;
}

export async function getMarketplaceOrderById(id) {
  const query = gql`
  {
      getOrder(uuid: "${id}") {
        uuid
        status
        trx_date
        updated_at
        is_online
        invoice_no
        created_at
        store{
          uuid
          platform
          market_name
        }
        marketplace_invoice
        branch {
          city
          name
          province
          uuid
        }
        member {
          name
          email
          hp
          uuid
          member_level_code
        }
        order_snapshot
        image_confirmation {
          url
        }
        order_payment {
          uuid
          amount
          pg_trx_id
          payment_method {
            code
            name
          }
      }
      order_item {
      product_sku_uuid
      product_sku {
        product {
          name
        }
        sku
        price
      }
      qty
      uuid
    }
        order_delivery {
          uuid
          awb
          province
          city
          codepos
          sub_district
          shipping_service {
            company_code
            service
          }
        }
      }
    }
`;

  const newResponse = await QueryGraphql(query);
  return newResponse.data.getOrder;
}

export const ORDER_ITEM_AND_DELIVERY = gql`
  mutation Mutation(
    $createOrderItemItems: [CreateOrderItemInput!]!
    $address: String!
    $city: String!
    $codepos: String!
    $order_uuid: String!
    $province: String!
    $receiver_hp: String!
    $receiver_name: String!
    $sub_district: String!
    $orderDeliveryUuid: String!
    $awb: String
    $trx_date: DateTime
    $status: String
  ) {
    createOrderItem(
      createOrderItemInput: { order_uuid: $order_uuid, items: $createOrderItemItems }
    ) {
      qty
      order_uuid
      uuid
      assigned_price
      product_snapshot
      product_sku_snapshot
    }
    updateOrderDelivery(
      updateOrderDeliveryInput: {
        address: $address
        city: $city
        codepos: $codepos
        order_uuid: $order_uuid
        province: $province
        receiver_hp: $receiver_hp
        receiver_name: $receiver_name
        sub_district: $sub_district
        uuid: $orderDeliveryUuid
      }
    ) {
      address
      city
      receiver_name
      receiver_hp
    }
    updateOrder(
      updateOrderInput: { uuid: $order_uuid, awb: $awb, status: $status, trx_date: $trx_date }
    ) {
      uuid
      marketplace_invoice
    }
  }
`;

export const UPDATE_ITEM_DELIVERY = gql`
  mutation Mutation(
    $orderItemInput: [UpdateOrderItemInput!]!
    $address: String!
    $city: String!
    $codepos: String!
    $order_uuid: String!
    $province: String!
    $receiver_hp: String!
    $receiver_name: String!
    $sub_district: String!
    $orderDeliveryUuid: String!
    $awb: String
    $store: String
    $status: String
    $trx_date: DateTime
  ) {
    updateOrderItem(updateOrderItemInput: $orderItemInput) {
      qty
      order_uuid
      uuid
    }
    updateOrderDelivery(
      updateOrderDeliveryInput: {
        address: $address
        city: $city
        codepos: $codepos
        order_uuid: $order_uuid
        province: $province
        receiver_hp: $receiver_hp
        receiver_name: $receiver_name
        sub_district: $sub_district
        uuid: $orderDeliveryUuid
      }
    ) {
      address
      city
      receiver_name
      receiver_hp
    }
    updateOrder(
      updateOrderInput: {
        uuid: $order_uuid
        awb: $awb
        store_uuid: $store
        status: $status
        trx_date: $trx_date
      }
    ) {
      uuid
      marketplace_invoice
    }
  }
`;

export const UPDATE_ORDER_AWB = gql`
  mutation ($uuid: String!, $awb: String) {
    updateOrder(updateOrderInput: { uuid: $uuid, awb: $awb }) {
      uuid
      marketplace_invoice
    }
  }
`;

export async function deleteMarketplaceOrder(id) {
  const query = gql`
    mutation Mutation {
      deleteMarketplaceOrder(marketplaceOrder_uuid: "${id}") {
        message
      }
    }
  `;

  const response = await MutationGraphql(query);
  return response.data.deleteMarketplaceOrder;
}

export function getAllMarketplaceOrders() {
  return axios.get(CUSTOMERS_URL);
}

// export function getMarketplaceOrderById(marketplaceOrderId) {
//   return axios.get(`${CUSTOMERS_URL}${marketplaceOrderId}`);
// }

// export function findMarketplaceOrders(queryParams) {
//   return axios.post(`${CUSTOMERS_URL}find`, queryParams );
// }

export function updateMarketplaceOrder(marketplaceOrder) {
  return axios.put(`${CUSTOMERS_URL}/`, marketplaceOrder);
}

// DELETE => delete the marketplaceOrder from the server
// export function deleteMarketplaceOrder(marketplaceOrderId) {
//   return axios.delete(`${CUSTOMERS_URL}/${marketplaceOrderId}`);
// }
